/**
 * One line in the desktop app's main.log ([call-renderer]) saying what a
 * call-state frame or a ring did, and why a frame changed nothing. Every drop
 * in the frame pipeline is silent by design (stale, duplicate, unrouted,
 * malformed), so without this a ring that outlives its call leaves no trace.
 *
 * Lines carry call ids, versions and statuses; the CALL_* lifecycle lines also
 * name the peer's opaque user id. Never names, SDP, ICE candidates or tokens.
 * No-op outside the desktop app.
 */
import { desktop } from '../electron';

export function logCallDiagnostic(message: string): void {
  try {
    desktop?.logCall?.(message);
  } catch {
    /* diagnostics must never break a call */
  }
}

/** Short, value-free description of a failed request for a diagnostic line. */
export function describeCallError(error: unknown): string {
  const status = (error as { response?: { status?: unknown } } | null)?.response?.status;
  if (typeof status === 'number') return `HTTP ${status}`;
  if (error instanceof Error) return error.message || error.name;
  return 'unknown error';
}
